import { faker } from '@faker-js/faker/locale/en';

export function mockUsers(length: number) {
  const createRowData = rowIndex => {
    const firstName = faker.name.firstName();
    const lastName = faker.name.lastName();
    const gender = faker.name.gender(true) as 'female' | 'male';
    const name = faker.name.findName(firstName, lastName, gender);
    const avatar = faker.image.avatar();

    const city = faker.address.city();
    const street = faker.address.street();
    const email = faker.internet.email();
    const postcode = faker.address.zipCode();
    const phone = faker.phone.number();
    const amount = faker.finance.amount(1000, 90000);

    const age = Math.floor(Math.random() * 30) + 18;
    const stars = Math.floor(Math.random() * 10000);
    const followers = Math.floor(Math.random() * 10000);
    const rating = 2 + Math.floor(Math.random() * 3);
    const progress = Math.floor(Math.random() * 100);
    
    const leaveBalance = Math.floor(Math.random() * 31);
    
    const registrationNumber = `EMP-2024-${String(rowIndex + 1).padStart(3, '0')}`;
    
    const departments = ['IT', 'HR', 'Finance', 'Marketing', 'Operations', 'Sales', 'Engineering'];
    const department = departments[Math.floor(Math.random() * departments.length)];

    const gpn = `GPN-${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`;
    
    const leaveTypes = ['Annual Leave', 'Sick Leave', 'Personal Leave', 'Maternity Leave', 'Paternity Leave'];
    const type = leaveTypes[Math.floor(Math.random() * leaveTypes.length)];
    
    const validator = faker.name.findName(); // Random validator name
    
    const createdAt = faker.date.recent(30).toISOString(); // Random date within last 30 days
    
    const statuses = ['Approved', 'Pending', 'Rejected'];
    const status = statuses[Math.floor(Math.random() * statuses.length)];

    // Generate unique WFH days
    const possibleDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const shuffledDays = possibleDays.sort(() => 0.5 - Math.random()); // Shuffle the days
    const wfhDays = shuffledDays.slice(0, Math.floor(Math.random() * 6) + 1); // Select 1 to 6 unique days

    return {
      id: rowIndex + 1,
      name,
      firstName,
      lastName,
      avatar,
      city,
      street,
      postcode,
      email,
      phone,
      gender,
      age,
      stars,
      followers,
      rating,
      progress,
      amount,
      leaveBalance,
      registrationNumber,
      department,
      gpn,
      type,
      validator,
      createdAt,
      status,
      wfhDays: wfhDays.join(' '), 
    };
  };

  return Array.from({ length }).map((_, index) => {
    return createRowData(index);
  });
}

export function mockTreeData(options: {
  limits: number[];
  labels: string | string[] | ((layer: number, value: string, faker) => string);
  getRowData?: (layer: number, value: string) => any[];
}) {
  const { limits, labels, getRowData } = options;
  const depth = limits.length;

  const data = [];
  const mock = (list, parentValue?: string, layer = 0) => {
    const length = limits[layer];

    Array.from({ length }).forEach((_, index) => {
      const value = parentValue ? parentValue + '-' + (index + 1) : index + 1 + '';
      const children = [];
      const label = Array.isArray(labels) ? labels[layer] : labels;

      let row: any = {
        label: typeof label === 'function' ? label(layer, value, faker) : label + ' ' + value,
        value
      };

      if (getRowData) {
        row = {
          ...row,
          ...getRowData(layer, value)
        };
      }

      list.push(row);

      if (layer < depth - 1) {
        row.children = children;
        mock(children, value, layer + 1);
      }
    });
  };

  mock(data);

  return data;
}

export function mockSpaces(floorId: string) {
  const spaces = [];
  const zonesMap = {
    '1': 'Parking',
    '2': 'Office Area',
    '3': 'Meeting Area'
  };
  
  const zone = zonesMap[floorId] || 'General';
  
  // Generate 20 spaces for each floor
  for(let i = 1; i <= 20; i++) {
    spaces.push({
      id: i,
      name: `${zone}-${i}`,
      availability: Math.random() > 0.3, // 70% chance of being available
      zone: `${zone} ${Math.ceil(i/5)}`, // Group spaces into zones of 5
      qrCode: `FLOOR-${floorId}-SPACE-${i}`
    });
  }
  
  return spaces;
}
